/**
 * Compute simple per-generation stats from a population.
 */
export function computePopulationStats<T>(pop: Array<{ g: T; f: number }>): {
  best: number
  mean: number
  invalidCount: number
  finiteCount: number
} {
  let best = -Infinity
  let finiteSum = 0
  let finiteCount = 0
  let invalidCount = 0
  for (let i = 0; i < pop.length; i++) {
    const f = pop[i].f
    if (f > best) best = f
    if (Number.isFinite(f)) {
      finiteSum += f
      finiteCount++
    } else {
      invalidCount++
    }
  }
  const mean = finiteCount ? finiteSum / finiteCount : -Infinity
  return { best, mean, invalidCount, finiteCount }
}

